define.alias("shared/components/shared/plan-recommendation/recommendation", "calendar/components/shared/plan-recommendation/recommendation");